export enum PriceType {
    Euro = "eur",
    Dollar = "usd",
}
